import * as firebase from 'firebase';

const prodConfig = {
  apiKey: "AIzaSyBEnORgv0zol8FbBRcagxMryoPCyjt3bys",
  authDomain: "uff-ride.firebaseapp.com",
  databaseURL: "https://uff-ride.firebaseio.com",
  projectId: "uff-ride",
  storageBucket: "uff-ride.appspot.com",
  messagingSenderId: "532514151049"
};


const devConfig = {
  apiKey: "AIzaSyBEnORgv0zol8FbBRcagxMryoPCyjt3bys",
  authDomain: "uff-ride.firebaseapp.com",
  databaseURL: "https://uff-ride.firebaseio.com",
  projectId: "uff-ride",
  storageBucket: "uff-ride.appspot.com",
  messagingSenderId: "532514151049"
};

const config = process.env.NODE_ENV === 'production'
  ? prodConfig
  : devConfig;

if (!firebase.apps.length) {
  firebase.initializeApp(config);
}

const db = firebase.database();
const auth = firebase.auth();
const functions = firebase.functions();

const messaging = firebase.messaging();
messaging.usePublicVapidKey("BPByPzPhUNQLG0wtV1d5l2Z8GyNT6c1L0As8twjtUrtOydUDsaeYdRB-Joe7IPtwCIdg3t6TsGgewTkkHBf454o");
// messaging.setBackgroundMessageHandler(function (payload) {
//   console.log('[firebase-messaging-sw.js] Received background message ', payload);
//   // Customize notification here
//   var notificationTitle = 'Background Message Title';
//   var notificationOptions = {
//     body: 'Background Message body.',
//     icon: '/firebase-logo.png'
//   };

//   return this.registration.showNotification(notificationTitle,
//     notificationOptions);
// });
export {
  db,
  auth,
  functions,
  messaging
};



// WEBPACK FOOTER //
// ./src/firebase/firebase.js